import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

import { ChakraProvider } from "@chakra-ui/react";
import { FeedInAppTheme } from './Components/Theme/theme.ts';
import { Provider } from 'react-redux';
import { store } from './Redux/Store/store';
import './i18n/i18n'; // <--- add this

ReactDOM.render(
  <React.StrictMode>
    <ChakraProvider theme={ FeedInAppTheme } resetCSS>
      <Provider store={ store }>
        <App />
      </Provider>
    </ChakraProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
